import { useState } from "react";
import OnlineDaywiseReport from "./OnlineReport";

const DaywiseReport = () => {
    const [selectedTab,setSelectedTab]=useState<("online"|"offline")>("online");
    return (
        <div>
            <div className="flex gap-2">
                <button onClick={()=>setSelectedTab("online")} className={selectedTab==="online"?"bg-emerald-600 text-white px-2 py-1 rounded":"bg-white text-gray-600 px-2 py-1 rounded"}>Online</button>
                <button onClick={()=>setSelectedTab("offline")} className={selectedTab==="offline"?"bg-emerald-600 text-white px-2 py-1 rounded":"bg-white text-gray-600 px-2 py-1 rounded"}>Offline</button>
            </div>
            {selectedTab==="online"?<OnlineDaywiseReport isOnline={true}/>:<OnlineDaywiseReport isOnline={false}/>}
        </div>
    );
};

export default DaywiseReport;
